




























































import _ from 'lodash'
import { Prop, Component } from 'vue-property-decorator'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { Getter, Action } from 'vuex-class'
import { UserProfile } from '@/store/modules/views/userProfile/states'
import { IRegisterFormData } from '@/store/modules/views/register/states'
import { getNationality } from '@/services/Nationality'
import { getEthnicity } from '@/services/Ethnicity'
import { getReligion } from '@/services/Religion'
import { getStatusUser } from '@/services/StatusUser'
import { getLanguage } from '@/services/Language'

@Component
export default class EditProfileDialog extends VueExtendedBaseComponent {

  get centerList() {
    return this.centerLists
  }

  get age() {
    const age = this.diffDate(this.date)
    const year = Math.floor(age)
    const month = Math.floor((age - year) * 12)
    return `อายุ ${ year ? year + 'ปี ' : '' }${ month }เดือน`
  }

  get invalidateInput() {
    return _.some(
        [
          this.validateInputFromType('phone', this.profile.phone, true),
          // this.validateInputFromType('cid', this.profile.idCard),
          this.requireInput(this.profile.sign),
        ],
        (item) => item !== true,
    )
  }

  get editProfileDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          action: this.submitData,
          loading: this.loading,
          height: '30',
          color: 'primary',
        },
      },
    }
  }

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', value)
  }
  @Prop() private open!: boolean
  @Prop() private callback!: () => void
  @Prop() private profile!: UserProfile

  private valid = false
  private loading = false
  private menu = false
  private activePicker = null
  private date = this.profile && this.profile.birthdate ? this.profile.birthdate : null
  private location: IRegisterFormData['address'] = {address: ''}
  private map = {
    lat: 0,
    lon: 0,
  }
  private caregiverLevelLists = [
    { text: 'ขั้นพื้นฐาน', value: '10' },
    { text: 'ขั้นสูง', value: '20' },
  ]
  private profileImg = ''
  private nationalityList = getNationality().nationality
  private ethnicityList = getEthnicity().ethnicity
  private religionList = getReligion().religion
  private statusUserList = getStatusUser().statusUser
  private languageList = getLanguage().language

  @Getter('components/prefixNames')
  private prefixNames: string[]

  @Getter('center/itemLists')
  private centerLists!: () => void

  @Action('user/editUser')
  private putProfile!: (options) => void

  private requireInput(value) { return value !== '' || 'จำเป็นต้องกรอก' }

  private async submitData() {
    this.loading = true
    if (!this.invalidateInput) {
      const data = {
        ...this.profile,
      }
      try {
        await this.putProfile(data)
        this.updateSnackbar({txt: 'บันทึกข้อมูลสำเร็จ', type: 'success'})
        await this.callback()
        this.closeDialog()
      } catch (error) {
        this.loading = false
      }
    } else {
      this.loading = false
      this.updateSnackbar({txt: 'ข้อมูลไม่ครบถ้วนกรุณาตรวจสอบอีกครั้ง', type: 'error'})
      return false
    }
  }

  private onInputImage(file) {
    this.profileImg = file.file
  }

  private closeDialog() {
    this.$emit('update:open', false)
  }

  private doSaveSign(sign) {
    this.profile.sign = sign
  }
}
